import PropTypes from 'prop-types';
import React from 'react';
import MediaQuery from 'react-responsive';
import { CUT_POINT } from 'config/constants';
import inputStyles from 'styles/input';
import S from '../styles.scss';

const EditableTableCell = (props, context) => {
  const { label, value, children, display, className, onChange, error, cellReadOnly } = props;
  if (!display) return null;
  let content = value;
  if (!context.disabled && context.isEditable && onChange && !context.readOnly && !cellReadOnly) {
    const newProps = { onChange: (event) => { context.onChange(event, onChange); } };
    content = React.Children.map(children, child => child && React.cloneElement(child, newProps));
  } else if (!context.disabled && context.isEditable && !context.readOnly && !cellReadOnly) {
    content = children;
  }
  const style = `${S.cell} ${className}`;
  const errWrapperStyles = `${inputStyles.errored} ${S.errored}`;
  const errStyles = `${inputStyles.error} ${S.error}`;
  let errorMsg = null;
  if (context.isEditable && error) {
    errorMsg = (<div className={errWrapperStyles}>
      <p className={errStyles}>{error}</p>
    </div>);
  }
  return (<td className={style}>
    <MediaQuery maxWidth={CUT_POINT}>{(match) => {
      if (match) return <div className={S.heading}>{label}</div>;
      return null;
    }}</MediaQuery>
    {content}
    {errorMsg}
  </td>);
};

EditableTableCell.contextTypes = {
  isEditable: PropTypes.bool,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
};

EditableTableCell.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.node.isRequired,
  children: PropTypes.node,
  display: PropTypes.bool.isRequired,
  className: PropTypes.string,
  onChange: PropTypes.func,
  error: PropTypes.string,
  cellReadOnly: PropTypes.bool,
};

EditableTableCell.defaultProps = {
  label: '',
  value: '',
  children: null,
  display: true,
  className: '',
  error: '',
  cellReadOnly: false,
};

export default EditableTableCell;



// WEBPACK FOOTER //
// ./client/app/shared/components/EditableTable/components/editableTableCell.jsx